import type { Editor } from "@tiptap/react";
import { useEffect, useState } from "react";

export const useEditorIsActive = (
  editorInstance: Editor | null,
  format: string,
) => {
  const [isActive, setIsActive] = useState(false);

  useEffect(() => {
    if (!editorInstance) return;

    const handler = () => {
      setIsActive(editorInstance.isActive(format));
    };

    // Initial check
    handler();

    editorInstance.on("selectionUpdate", handler);
    editorInstance.on("update", handler);

    return () => {
      editorInstance.off("selectionUpdate", handler);
      editorInstance.off("update", handler);
    };
  }, [editorInstance, format]);

  return isActive;
};
